export default __webpack_public_path__ + "static/media/SCRIPT_DISABLE.18bb2e53.png";